// extracted by mini-css-extract-plugin
export default {"cardPillsAndIndicatorsContainer":"CardPillsAndIndicators_cardPillsAndIndicatorsContainer__YNUwJ","pills":"CardPillsAndIndicators_pills__JKruO"};